module.exports = __webpack_public_path__ + "images/柏纳长图_03.jpg?v=5070db8f";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan1/柏纳长图_03.jpg
 ** module id = 138
 ** module chunks = 1 2
 **/